import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import { FaLinkedinIn, FaInstagram } from 'react-icons/fa';
import { ArrowUpRight } from 'lucide-react';

const courses = [
  { courseId: 'staad-pro', title: 'STAAD Pro' },
  { courseId: 'sewergems', title: 'OpenFlows SewerGEMS' },
  { courseId: 'microstation', title: 'MicroStation' },
  { courseId: 'openroads-designer', title: 'OpenRoads Designer' },
  { courseId: 'watergems', title: 'OpenFlows WaterGEMS' },
];

const services = [
  { name: 'Medini EduTech', desc: 'Training and Certifications', url: 'https://mediniedutech.com/' },
  { name: 'BIM Construct', desc: 'Interior and Exterior Designing', url: 'https://bimconstruct.in/' },
  { name: 'TechVruddhi', desc: 'Software Development', url: 'https://nalaneel.com/' },
  { name: 'EDUPHYGITAL', desc: 'Centre of Excellence', url: 'https://eduphygital.com/' },
  { name: 'DigiDhvani', desc: 'Digital Marketing', url: 'https://digidhvani.com/' },
  { name: 'BuilddSpace', desc: 'Incubation Centre', url: 'https://builddspace.in/' },
];

const BENTLEY_BASE_URL = 'https://bentley.mediniedutech.com/course';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Brand / About column */}
        <div className="footer-brand">
          <h3 className="footer-logo">Medini Technologies</h3>
          <p className="footer-tagline">
            Empowering engineers and designers with industry-recognized
            Bentley Systems training and certification programs.
          </p>
          <div className="social-icons">
            <a
              href="https://www.linkedin.com/company/medinitechnologies/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <FaLinkedinIn size={18} />
            </a>
            <a
              href="https://www.instagram.com/medinitechnologies/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <FaInstagram size={18} />
            </a>
          </div>
        </div>

        {/* Courses column */}
        <div className="footer-courses">
          <h4>Courses</h4>
          <ul>
            {courses.map((course) => (
              <li key={course.courseId}>
                <a
                  href={`${BENTLEY_BASE_URL}/${course.courseId}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {course.title}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Services column */}
        <div className="footer-services">
          <h4>Our Ventures</h4>
          <ul>
            {services.map((service) => (
              <li key={service.name}>
                <a href={service.url} target="_blank" rel="noopener noreferrer">
                  <span className="service-name">
                    {service.name}
                    <ArrowUpRight size={12} className="service-arrow" />
                  </span>
                  <span className="service-desc">{service.desc}</span>
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Quick links column */}
        <div className="footer-links">
          <h4>Quick Links</h4>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/#courses">Courses</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Medini Technologies. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;